import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeRepasUnite = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Listerepasunitereport"} />
        </div>
    );
}
export default ListeRepasUnite;